export default "__VITE_ASSET__BF$QxyDS__"